<template>
  <div>
    <template v-for="(item, index) in data">
      <div v-if="item.children?.length > 0" :key="index">
        <el-submenu :index="item.path" v-if="item.show">
          <template slot="title">
            <!-- <i :class="item.meta?.icon"></i> -->

            <img :src="item.meta?.icon" alt="" />
            <span style="margin-left: 5px">{{ item.meta?.title }}</span>
          </template>
          <el-menu-item-group>
            <myitem :data="item.children"></myitem>
          </el-menu-item-group>
        </el-submenu>
      </div>
      <!-- 情况二：没子集的情况： -->
      <div v-else :key="item.path">
        <el-menu-item v-if="item.show" :index="item.path">
          <!-- <i :class="item.meta?.icon"></i> -->
          <img
            v-if="item.meta?.icon"
            style="width: 20px; height: 20px"
            :src="item.meta?.icon"
            alt=""
          />
          <span style="margin-left: 5px" slot="title">{{
            item.meta?.title
          }}</span>
        </el-menu-item>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "myitem",
  props: ["data"],
  methods: {
    // toPath(item) {
    //   this.$router.push(item.path)
    // }
  }
};
</script>
<style lang="scss"></style>
